import ExperienceFacetModal, { FacetOption } from './ExperienceFacetModal';
import { ExperienceScope } from './ExperienceScopeSelector';

const countryNames = new Intl.DisplayNames(['en'], { type: 'region' });
const getCountryName = (code: string) => { try { return countryNames.of(code) || code; } catch (e) { return code; } };

const renderCountryLabel = (option: FacetOption) => (
  <>
    <span
      className={`fi fi-${option.key.toLowerCase()}`}
      style={{ width: 16, height: 12, borderRadius: 1, boxShadow: '0 0 0 0.5px rgba(0,0,0,0.15)', flexShrink: 0 }}
    />
    <span style={{ fontSize: 14, color: '#333' }}>{getCountryName(option.key)}</span>
  </>
);

interface Props {
  visible: boolean;
  onClose: () => void;
  onSave: (keys: string[], labels: string[], scope: ExperienceScope, operator: 'and' | 'or') => void;
  options: FacetOption[];
  initialSelected: string[];
  initialScope?: ExperienceScope;
  initialOperator?: 'and' | 'or';
  onScopeChange?: (scope: ExperienceScope) => void;
}

const CountryFilterModal = (props: Props) => (
  <ExperienceFacetModal
    {...props}
    title="Client Countries"
    description="Find people who have worked for clients registered in a specific country"
    color="#4A90D9"
    searchPlaceholder="Search countries..."
    emptyLabel="No countries selected"
    renderLabel={renderCountryLabel}
    searchFilter={(option, query) => getCountryName(option.key).toLowerCase().includes(query.toLowerCase())}
  />
);

export default CountryFilterModal;
